<template lang="pug">
div(class="subscription-page")
    div(class="layout-row")
        Sidebar
        div(class="main-content d-flex flex-column")
            //- div(class="header-content d-flex flex-column justify-content-start mb-4")
            //-     h2 Subscription Management
            //-     p Create and manage subscription packages
            SubscriptionsTab
</template>

<script>
import Sidebar from '../components/v2/Sidebar.vue';
import SubscriptionsTab from '../components/subscription/SubscriptionsTab.vue';

export default {
    components: {
        Sidebar,
        SubscriptionsTab,
    }
}
</script>

<style lang="scss" scoped>
.subscription-page {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    background: #f7f7fb;
    font-family: 'Inter', Arial, sans-serif;
    
    .layout-row {
        display: flex;
        height: 100%;
        
        .main-content {
            flex: 1;
            padding: 32px 48px;
            
            .header-content {
                margin-bottom: 32px;
                
                h2 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #374151;
                    margin-bottom: 8px;
                }
                
                p {
                    color: #6b7280;
                    font-size: 1rem;
                    margin: 0;
                }
            }
        }
    }
}
</style>